import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { ErrorBoundary } from '../shared/components/ErrorBoundary';
import { Loader } from '../shared/components/Loader';

import { RecoverPasswordErrorFallback } from './RecoverPasswordErrorFeedback';
import styles from './RecoverPasswordPage.module.scss';
import { RecoverPasswordSuccess } from './RecoverPasswordSuccess';
import { StartPasswordRecoveryForm } from './StartPasswordRecoveryForm';
import { UpdatePasswordForm } from './UpdatePasswordForm';

export function RecoverPasswordPage() {
  return (
    <div className={styles.content}>
      <ErrorBoundary fallback={<RecoverPasswordErrorFallback />}>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route index element={<StartPasswordRecoveryForm />} />
            <Route path="update-password" element={<UpdatePasswordForm />} />
            <Route path="success" element={<RecoverPasswordSuccess />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}
